import { Link } from 'react-router-dom';

const steps = [
  { num: '01', title: 'Spreadsheet öffnen', desc: 'Rufe das OOPBuy Spreadsheet auf und verschaffe dir einen ersten Überblick über die verfügbaren Kategorien.' },
  { num: '02', title: 'Kategorie auswählen', desc: 'Wähle aus 14 verschiedenen Kategorien die passende für deine Suche aus – von Schuhen bis zu Accessoires.' },
  { num: '03', title: 'Produkte vergleichen', desc: 'Nutze die strukturierte Ansicht, um Preise, Qualität und Bewertungen verschiedener Produkte direkt zu vergleichen.' },
  { num: '04', title: 'Informationen prüfen', desc: 'Überprüfe alle Details, QC-Fotos und Nutzererfahrungen, bevor du eine Kaufentscheidung triffst.' },
  { num: '05', title: 'Zum Portal wechseln', desc: 'Wenn du deine Auswahl getroffen hast, wechsle direkt zum Hauptportal für den Kauf.' },
];

export default function HowItWorks() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wider mb-2">
            Schritt für Schritt
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            So funktioniert OOPBuy Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative">
              <div className="bg-white rounded-lg p-5 md:p-6 h-full">
                <span className="font-heading text-3xl md:text-4xl font-bold text-primary-200 block mb-3">
                  {step.num}
                </span>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-2">
                  {step.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {step.desc}
                </p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-foreground-300">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Kompletten Guide lesen
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}